import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AccountService } from '../../../../../../../services/account/account.service';
import { DocumentTemplateService } from '../../../../../../../services/document-template/document-template.service';
import { DocumentPolicy, DocumentPolicyStatus } from '../../../../../../../models/document-template';

@Component({
  selector: 'app-document-policy-add',
  templateUrl: './document-policy-add.component.html',
  styleUrls: ['./document-policy-add.component.css']
})
export class DocumentPolicyAddComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private documentTemplateService: DocumentTemplateService
  ) {}

  public documentPolicy: DocumentPolicy;

  public documentPolicyErrorMessage = '';
  public documentPolicyErrors: any = {};

  public loadingPolicy = false;

  public serverError: number = null;

  ngOnInit() {
    this.documentPolicy = {
      id: null,
      url: '',
      name: '',
      status: DocumentPolicyStatus.active,
      content: '',
      containing_document_template_ids: [],
      climber_app_url: '',
      created_at: '',
      updated_at: ''
    };
  }

  public handleSave() {
    this.loadingPolicy = true;

    this.documentPolicyErrorMessage = '';

    this.documentTemplateService
      .addDocumentPolicy(this.documentPolicy)
      .then(updatedDocumentPolicy => {
        this.documentPolicy = updatedDocumentPolicy;

        this.router.navigate(
          ['/document-policies'],
          {
            state: {
              feedback: {
                text: 'Policy \'' + this.documentPolicy.name + '\' added successfully.',
                status: 'success'
              }
            }
          }
        );
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.documentPolicyErrors = reason.error;
          this.documentPolicyErrorMessage = 'Please correct the provided errors and try again.';
        } else if (reason.status === 403) {
          this.documentPolicyErrorMessage = 'You do not have permission to create document policies.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingPolicy = false; });
  }

}
